module.exports = __webpack_public_path__ + "img/shield.8f8be094.jpg";